import api from './api'

const contactBasePath = '/api/v1/contact'

export async function contact(contactData) {
  const resp = await api.post(`${contactBasePath}`, contactData)
  return resp.data
}
